import axios from 'axios'

function clone(obj) {
    return JSON.parse(JSON.stringify(obj))
}

const state = () => ({
    isOpenDialog: false,
    isEditableForm: false,
    formType: '',
    editingId: '',
    Name: '',
    Timestamp: '',
    dborigins: [],
    paths: {
        originsPath: '/api/servicios/origenesbd/',
    }
})

const mutations = {
    isOpenDialog: (state, val) => {
        state.isOpenDialog = val;
    },
    isEditableForm: (state, val) => {
        state.isEditableForm = val;
    },
    formType: (state, val) => {
        state.formType = val;
    },
    editingId: (state, val) => {
        state.editingId = val;
    },
    Name: (state, val) => {
        state.Name = val
    },
    Timestamp: (state, val) => {
        state.Timestamp = val
    },
    dborigins: (state, val) => {
        state.dborigins = clone(val)
    },
}

const actions = {
    async getOrigins({ dispatch, getters, state, commit }) {
        try {
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.originsPath))
            commit('dborigins', resp.data)

            // dispatch('util/showStatusSnackBar', {
            //     statusType: 'success',
            //     message: 'Origenes BD Cargados Correctamente'
            // }, {root: true})
        }
        catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo cargar el contenido de Origenes BD'
            }, { root: true })
        }
    },
    async delete({ state, dispatch, getters }, item) {
        try {
            await axios.delete(getters.getEndpointFromPath(state.paths.originsPath) + item.id)
            dispatch('getOrigins')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Entrada borrada'
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo eliminar la entrada'
            }, { root: true })
        }
    },
    async addOrigin({ state, getters, dispatch }) {
        let origin = {
            'nombre': state.Name,
            'timestamp': state.Timestamp,
        }

        try {
            await axios.post(getters.getEndpointFromPath(state.paths.originsPath), origin)
            dispatch('getOrigins')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Origen Añadido Correctamente',
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Error al Añadir Origen',
            }, { root: true })
        }
    },
    async editOrigin({ state, getters, dispatch }) {
        let origin = {
            'nombre': state.Name,
            'timestamp': state.Timestamp,
        }

        try {
            await axios.put(getters.getEndpointFromPath(state.paths.originsPath) + state.editingId + '/', origin)

            dispatch('getOrigins')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Origen Actualizado Correctamente',
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Error al Actualizar el Origen',
            }, { root: true })
        }
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    )
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}